import { memo, useEffect, useState } from "react";
import { BzModal, BzModalBody } from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getAppInfoData } from "../../utils/global_functions";
import { APP_INFO_PARAMS } from "../../utils/global_variables";


const DevToolsMsgModal = () => {
    const modals = useSelector(state => state.modals.modals);
    const { appInfo } = useSelector(state => state.appInfo);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        const devtolsmsg = getAppInfoData(APP_INFO_PARAMS.APP_DEV_TOOLS_MSG, appInfo);
        if (devtolsmsg?.length > 0) {
            setMsg(devtolsmsg);
        } else {
            setMsg("Kindly close the devtools to use the app.");
        }
    }, [appInfo]);
    return (
        <BzModal centered show={modals['DEV_TOOLS_MODAL']}>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <div>{msg}</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(DevToolsMsgModal)

